import { Injectable } from "@angular/core";
import * as _ from 'lodash';

export interface Storage {
    clear();
    getItem(key: string): string;
    removeItem(key: string);
    setItem(key: string, value: string);
}

export interface StorageDefinition {
    remember?: boolean;
}

@Injectable({
    providedIn: 'root'
})
export class StorageService {
    protected store: string = 'localStorage';       // default to localStorage

    public get instance(): Storage {
        return window[this.store];
    }

    public init(value?: string | StorageDefinition) {
        if (_.isNil(value)) {
            // no-op... leave everything as it is
        } else if (typeof value == 'string') {
            this.initByKey(value as string);
        } else {
            this.initByDefinition(value as StorageDefinition);
        }
    }

    protected initByDefinition(value: StorageDefinition) {
        if (!value.remember) {
            this.store = 'sessionStorage';
        } else {
            this.store = 'localStorage';
        }
    }

    protected initByKey(value: string) {
        if (/^(local|session)Storage$/.test(value)) {       // see if we are explictly defined
            this.store = value;
        } else if (localStorage.getItem(value)) {       // now test keys
            this.store = 'localStorage';
        } else if (sessionStorage.getItem(value)) {
            this.store = 'sessionStorage';
        }
    }
}
